export default __webpack_public_path__ + "static/media/lh.3132b5cc.svg";